import { FormDocument, FormDocumentAttachment } from '@/features/ui/DocumentsData/model/types';

import {
  AttachmentPayload,
  pushAttachment,
  addDocumentAttachments,
  toArray,
} from '@/shared/lib/helpers/payloadHelpers';

import { getERZDocumentTypeEntites } from '@/modules/erz/helpers';

import { ServiceFileManager } from '@/helpers/serviceFileManager';

import { DocumentTypeCode, FormDataType } from '@/api/types';

export const collectAttachments = (formData: FormDataType, hasActualAddress: boolean): AttachmentPayload[] => {
  const attachments: AttachmentPayload[] = [];

  pushAttachment(attachments, formData.photoCard as FormDocumentAttachment, 'photoCard');

  const rnokppAttachment = Array.isArray(formData.rnokppDoc)
    ? (formData.rnokppDoc[0] as FormDocumentAttachment | undefined)
    : (formData.rnokppDoc as FormDocumentAttachment | undefined);

  pushAttachment(attachments, rnokppAttachment, 'rnokppDoc');

  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.personPassportDocument as Nullable<FormDocument | FormDocument[]>),
    'personPassportDocument',
  );
  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.declaredDocRent as Nullable<FormDocument | FormDocument[]>),
    'declaredDocRent',
    'default',
    'REGISTRATION',
  );

  if (hasActualAddress) {
    addDocumentAttachments(
      attachments,
      toArray<FormDocument>(formData.actualPlaceOfResidence as Nullable<FormDocument | FormDocument[]>),
      'actualPlaceOfResidence',
      'default',
      'LIVING',
    );
  }

  addDocumentAttachments(
    attachments,
    toArray<FormDocument>(formData.reapplicationDocuments as Nullable<FormDocument | FormDocument[]>),
    'reapplicationDocuments',
  );

  return attachments;
};

export const generateApplicationAttachment = async (
  serviceFileManager?: ServiceFileManager | null,
): Promise<AttachmentPayload | null> => {
  const applicationFileId = serviceFileManager?.getAttachment()?.fileId ?? undefined;
  if (!applicationFileId) {
    return null;
  }

  const [pdfDocumentType] = await getERZDocumentTypeEntites([DocumentTypeCode.REAPPLICATION]);
  const pdfCode = pdfDocumentType?.code && pdfDocumentType.code !== 'null' ? pdfDocumentType.code : pdfDocumentType?.id;
  const pdfLabel = pdfDocumentType?.label ?? pdfDocumentType?.id ?? 'application';
  const pdfId = pdfDocumentType?.id ?? pdfCode ?? pdfLabel;

  if (pdfDocumentType && pdfId && pdfCode && pdfLabel) {
    return {
      id: pdfId,
      typeDoc: pdfLabel,
      fileName: pdfLabel,
      code: pdfCode,
      info: {},
      formField: 'application',
      files: [applicationFileId],
    };
  }

  return null;
};
